export const months = [
  { initials: 'Jan', description: 'Janeiro' },
  { initials: 'Fev', description: 'Fevereiro' },
  { initials: 'Mar', description: 'Março' },
  { initials: 'Abr', description: 'Abril' },
  { initials: 'Mai', description: 'Maio' },
  { initials: 'Jun', description: 'Junho' },
  { initials: 'Jul', description: 'Julho' },
  { initials: 'Ago', description: 'Agosto' },
  { initials: 'Set', description: 'Setembro' },
  { initials: 'Out', description: 'Outubro' },
  { initials: 'Nov', description: 'Novembro' },
  { initials: 'Dez', description: 'Dezembro' },
];
